import { useEffect } from "react";

export const useFastPolling = (callback, delay = 12000, enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    const interval = setInterval(() => {
      callback();
    }, delay);
    return () => clearInterval(interval);
  }, [callback, delay, enabled]);
};